<template>
  <v-main class="pa-4" fluid>
    <v-row>

      <v-snackbar v-model="snackbar" :timeout="8000" top :color="color">
        {{text}}
        <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
      </v-snackbar>

      <v-col cols="12">
        <v-card class="shadowCard">

          <v-card-title primary-title>
	  		    <span class="text-h5 font-weight-bold"> Familias </span>
	  		    <v-spacer></v-spacer>
	  		    <v-btn color="secondary" dark small class="mr-2" @click="nuevaFamilia = true ">
              Nueva Familia
            </v-btn>
	  		  </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-spacer></v-spacer>
                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    name="name"
                    label="Buscar"
                    id="id"
                    dense
                    hide-details
                    append-icon="mdi-magnify" 
                    v-model="search"
                    clearable
                  ></v-text-field>
                </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="familias"
                  sort-by="estatus"
                  class="elevation-0"
                  :search="search"
                  :loading="loading"
                  :height="tamanioPantalla"
                  fixed-header
                  hide-default-footer
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                          <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.editar="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="editItem(item)"
                      color="blue"
                    >
                      mdi-pencil
                    </v-icon>
                  </template>
                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                    >
                      Reset
                    </v-btn>
                  </template>

                  <template v-slot:item.estatus="{ item }">
                    <v-chip v-if="item.estatus == 1" color="green" dark small>Activo</v-chip>
                    <v-chip v-else color="red" dark small>Inactivo</v-chip>
                  </template>

               
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>

        </v-card>
      
      </v-col>


      <v-dialog v-model="nuevaFamilia" max-width="500px">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text class="pb-0">
              <v-text-field
                v-model="editedItem.familia"
                label="Familia"
                outlined
                dense
                :rules="[v => !!v || 'Campo requerido']"
              ></v-text-field>

              <v-checkbox 
                label="Estatus" 
                v-model="editedItem.estatus" 
              >
              </v-checkbox>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="nuevaFamilia = false">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text @click="save()">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>


    </v-row>
  </v-main>
</template>
<script>
  import  metodos from '@/mixins/metodos.js';

  export default {
    mixins:[metodos],

    data: () => ({
    	loading: false,
      valid: true,
      search:'',
      text:'',
      color:'',
      snackbar: false,
      dialog: false,
      dialogDelete: false,
      headers: [
        { text: 'Id', align: 'left',sortable: false, value: 'idfamilias'},
        { text: 'Nombre', align: 'left',sortable: false, value: 'familia'},
        { text: 'Estatus', align: 'left',sortable: false, value: 'estatus'},
        { text: 'Editar', align: 'left',sortable: false, value: 'editar'},
      ],

      familias: [],
      nuevaFamilia: false,
      editedIndex: -1,
      editedItem: {
        idfamilias:0,
        familia: '',
        estatus: 0,
      },
      defaultItem: {
        idfamilias:0,
        familia: '',
        estatus: 0,
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva Familia' : 'Editar Familia'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {

      initialize () {
      	this.loading = true
        this.familias = []
        this.$http.get('familias.all').then(response =>{
          this.loading = false
          this.familias = response.body

          this.familias.forEach(element=>{
            element.estatus == 1 ? true:false
          })
      		this.loading = false

        })
      },

      editItem (item) {
        this.editedIndex = this.familias.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.editedItem.estatus = this.editedItem.estatus == 0 ? false : true
      },

      deleteItem (item) {
        this.editedIndex = this.familias.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.familias.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if(this.$refs.form.validate()){
          this.editedItem.estatus == false ? 0 : 1

          if (this.editedIndex > -1) {
            this.$http.put('familias.update/'+ this.editedItem.idfamilias, this.editedItem).then(response=>{
              this.text  = 'Familia actualizada'
              this.snackbar = true
              this.color = 'green'
              this.nuevaFamilia = false;
              this.initialize()
            })
          } else {
            this.$http.post('familias.add', this.editedItem).then(response=>{
              this.text  = 'Familia agregada'
              this.snackbar = true
              this.color = 'green'
              this.initialize()
            })
          }
          this.close()
        }
    },
  },
  }
</script>